// importation des bibliothèques de modules node
import React, { useEffect, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

// importation du profil layout wrapper
import LocalProfileLayout from './LocalProfileLayout';

import TypeLocalService from '../../services/TypeLocalService';

const DeleteLocal = () => {
	const [local, setStudent] = useState(null);
	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		Promise.all([TypeLocalService.getTypeLocal(id)]).then(([typelocalData]) => {
			setStudent(typelocalData.data);
		});
	}, [id]);

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			// Call the TypeLocalService to delete the local
			await TypeLocalService.deleteTypeLocal(id);

			// Redirect the user to the list of locals
			navigate('/locaux/autres');
		} catch (error) {
			console.error(
				"Erreur lors de la suppression des informations du local",
				error
			);
		}
	};

	return (
		<LocalProfileLayout>
			{local && (
				<>
					{/*  Form  */}
					<Form className="mb-3" onSubmit={handleSubmit}>
						<Card className="border-0">
							<Card.Header>
								<div className="mb-3 mb-lg-0">
									<h3 className="mb-0">
										Supprimer{' '}
										<span className="text-uppercase">{local.nom || ''}</span>
									</h3>
									<p className="mb-0">
										Supprimez définitivement ce local.
									</p>
								</div>
							</Card.Header>
							<Card.Body>
								<span className="text-danger h4">Attention</span>
								<p>
									Si vous supprimez ce local, toutes les données le concernant seront
									définitivement perdues.
								</p>
								<Button variant="danger" type="submit">
									Supprimer le local
								</Button>
							</Card.Body>
						</Card>
					</Form>
				</>
			)}
		</LocalProfileLayout>
	);
};

export default DeleteLocal;
